import styles from "./type-selector.module.css";

import { inject, observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { MenuItem, OutlinedInput, Select } from "@mui/material";
import UserSettingsStore, {
    UserSettings,
} from "../../../../../store/user-settings";

export interface ZoomLevelToggleProps {
    userSettingsStore?: UserSettingsStore;
}

function TypeSelector(props: ZoomLevelToggleProps) {
    const userSettingsStore = props.userSettingsStore!;

    const type = userSettingsStore.getUserSetting(UserSettings.CHART_TYPE);

    const { t } = useTranslation("dashboard");

    const handleChange = (event: any) => {
        userSettingsStore.setUserSetting(
            UserSettings.CHART_TYPE,
            event.target.value
        );
    };

    const render = () => {
        return (
            <div className={styles["container"]}>
                <Select
                    sx={{
                        ".MuiOutlinedInput-notchedOutline": {
                            border: "1px solid rgba(23, 53, 68, 0.60)",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            border: "1px solid rgba(23, 53, 68, 1)",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            border: "1px solid rgba(23, 53, 68, 1)",
                        },
                        textTransform: "uppercase",
                    }}
                    value={type}
                    onChange={handleChange}
                    inputProps={{ textTransform: "uppercase" }}
                    MenuProps={{
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                        },
                        transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                        },
                    }}
                >
                    <MenuItem value={"daily"}>{t("DailyView")}</MenuItem>
                    <MenuItem value={"night"}>{t("NightView")}</MenuItem>
                    <MenuItem value={"compare"}>{t("ComparePeriods")}</MenuItem>
                </Select>
            </div>
        );
    };

    return render();
}

export default inject("userSettingsStore")(observer(TypeSelector));
